interface FetchState {
  fetching: boolean;
  stale?: boolean;
  error?: unknown;
}

/** urql never clears `stale` on a failed result, so staleness counts as fetching only without an error. */
export const isFetchingResult = ({ fetching, stale, error }: FetchState): boolean =>
  fetching || (Boolean(stale) && !error);
